//Modal para editar el nombre de una lista.
import { useEffect, useState } from "react";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    CircularProgress,
} from "@mui/material";

import { editarLista } from "../api/listas";

export default function EditarListaModal({ open, onClose, lista, onUpdated }) {
    const [nombre, setNombre] = useState("");
    const [guardando, setGuardando] = useState(false);

    // Precarga el nombre actual
    useEffect(() => {
        if (lista) {
            setNombre(lista.nombre || "");
        }
    }, [lista]);

    async function handleGuardar() {
        if (!nombre.trim()) return;

        setGuardando(true);
        try {
            await editarLista(lista.idlista, { nombre });
            onUpdated(); // refresca listas
            onClose();
        } catch (err) {
            console.error("Error editando lista:", err);
        } finally {
            setGuardando(false);
        }
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Editar lista</DialogTitle>

            <DialogContent>
                <TextField
                    label="Nombre de la lista"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    fullWidth
                    autoFocus
                    sx={{ mt: 1 }}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={guardando}>
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    onClick={handleGuardar}
                    disabled={!nombre.trim() || guardando}
                >
                    {guardando ? <CircularProgress size={20} /> : "Guardar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
